import { render, staticRenderFns } from "./ProfileBasicDetails.vue?vue&type=template&id=13e60717&scoped=true"
import script from "./ProfileBasicDetails.vue?vue&type=script&lang=js"
export * from "./ProfileBasicDetails.vue?vue&type=script&lang=js"
import style0 from "./ProfileBasicDetails.vue?vue&type=style&index=0&id=13e60717&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e60717",
  null
  
)

export default component.exports